import { gql } from '@apollo/client';

export default gql`
  mutation deleteAllSessionInfos {
    deleteAllSessionInfos(input: {}) {
      success
    }
  }
`;
